<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold" :for="name"
      >{{ label }}<span v-if="required" class="text-red-600">*</span></label
    >
    <input
      class="rounded border px-5 py-3"
      :name="name"
      :required="required"
      :id="name"
      :type="type"
      :value="inputValue"
      :placeholder="placeholder"
      @input="handleChange"
      @blur="handleBlur"
    />

    <p class="text-red-500" v-show="errorMessage || meta.valid">
      {{ errorMessage }}
    </p>
  </div>
</template>
<script>
import { toRef } from 'vue';
import { useField } from 'vee-validate';
import * as yup from 'yup';
import { useI18n } from 'vue-i18n';

export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    defaultSingleValue: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    successMessage: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: true,
    },
    property: {
      type: Number,
      default: undefined,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const name = toRef(props, 'name');
    let rules = yup
      .string()
      .transform(v => (v == null ? '' : v))
      .nullable();
    if (props.required) {
      rules = rules.required(t('warning.REQUIRED_MESSAGE'));
    }
    const {
      meta,
      value: inputValue,
      errorMessage,
      validate,
      handleBlur,
      handleChange,
    } = useField(name, rules, {
      initialValue: props.defaultSingleValue,
    });
    return {
      inputValue,
      errorMessage,
      validate,
      meta,
      handleBlur,
      handleChange,
    };
  },
  methods: {
    async validateField() {
      const validatedData = await this.validate();
      return {
        value: this.inputValue,
        valid: validatedData.valid,
        mode: 'single',
        property: this.property,
      };
    },
  },
};
// const props = defineProps();

// use `toRef` to create reactive references to `name` prop which is passed to `useField`
// this is important because vee-validte needs to know if the field name changes
// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
// const name = toRef(props, 'name');

// we don't provide any rules here because we are using form-level validation
// https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
// const {
//   value: inputValue,
//   errorMessage,
//   handleBlur,
//   handleChange,
//   meta,
// } = useField(name, undefined, {
//   initialValue: props.value,
// });
// const hello = () => {
//   console.log('Hello from TextField')
// }
</script>

<style scoped></style>
